import {
  CiselnikPolozka,
  SprievodnyDokument as SprievodnyDokumentGenerated,
  SprievodnyDokumentListApi,
} from 'evidencna-aplikacia-frontend-ts-axios';
import { ClientResponse } from '../../../model/ClientResponse';
import apiConfiguration from '../../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import Uuid from '../../../model/Uuid';
import SprievodnyDokument from '../../../model/legislativnyMaterial/SprievodnyDokument';
import PolozkaCiselnik from '../../../model/ciselniky/PolozkaCiselnik';

const client = new SprievodnyDokumentListApi(apiConfiguration(evidenciaPrefixPath));

function map(data: SprievodnyDokumentGenerated[]):SprievodnyDokument[] {
  return data.map(dokument => ({
    uuid: dokument.uuid,
    typ: dokument.typ ? mapTyp(dokument.typ) : null,
    velkost: dokument.velkost,
    nazov: dokument.nazov,
  }));
}
const mapTyp = (data: CiselnikPolozka): PolozkaCiselnik => ({
  uuid: data.uuid,
  nazov: data.nazov,
  platny: data.platny,
  existujeFormular: data.existujeFormular,
  povolitZadavanieFormularom: data.povolitZadavanieFormularom,
  generovanySystemom: data.generovanySystemom,
});

// eslint-disable-next-line import/prefer-default-export
export const fetchSprievodnyDokumentList = async (uuid: Uuid, stadiumUuid: Uuid, headers?: object):
  Promise<ClientResponse<Array<SprievodnyDokument>>> => {
  const {
    data,
    status,
  } = await client.getSprievodnyDokumentList(uuid, stadiumUuid, headers);
  return {
    data: map(data),
    responseCode: status,
  };
};
